import React, { createContext, useContext, useState, useCallback } from 'react';
import { Backdrop, CircularProgress } from '@mui/material';

const LoadingContext = createContext();

export const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

export const LoadingProvider = ({ children }) => {
  const [loadingStack, setLoadingStack] = useState([]);

  const showLoading = useCallback((key = 'default') => {
    setLoadingStack(prev => {
      if (!prev.includes(key)) {
        return [...prev, key];
      }
      return prev;
    });
  }, []);

  const hideLoading = useCallback((key = 'default') => {
    setLoadingStack(prev => prev.filter(k => k !== key));
  }, []);

  const isLoading = loadingStack.length > 0;

  const value = {
    showLoading,
    hideLoading,
    isLoading,
  };

  return (
    <LoadingContext.Provider value={value}>
      {children}
      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1000,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </LoadingContext.Provider>
  );
};
